var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconBookmarkLight = function SvgIconBookmarkLight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#icon_bookmark_light_svg__a)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#121619"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.7 12.2a2.485 2.485 0 0 0-2.5 2.5v21.2c0 .062.014.088.018.094a.071.071 0 0 0 .028.026.17.17 0 0 0 .152 0l9.177-4.987a1.1 1.1 0 0 1 1.05 0L33.8 36.02c.025.01.07.015.13-.022.03-.018.05-.04.06-.056A.072.072 0 0 0 34 35.9V14.7c0-1.393-1.108-2.5-2.5-2.5H16.7ZM12 14.7c0-2.607 2.092-4.7 4.7-4.7h14.8c2.608 0 4.7 2.092 4.7 4.7v21.2c0 1.74-1.88 2.84-3.392 2.084a1.057 1.057 0 0 1-.033-.017L24.1 33.252l-8.675 4.715a1.057 1.057 0 0 1-.033.017C13.947 38.706 12 37.813 12 35.9V14.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29 20.7h-9.8v-2.2H29v2.2Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "icon_bookmark_light_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h48v48H0z"
  })))));
};
export default SvgIconBookmarkLight;